import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";

const FooterMobile = () => {
    return (
        <Fragment>
            <div style={{ marginTop: "35px" }}>
                <div>
                    <ul className="company-social" style={{ textAlign: "center", border: "0.2px solid transparent" }}>
                        <li className="social-facebook">
                            <a href="https://www.facebook.com/KabraExpressLogistics">
                                <i className="fa fa-facebook"></i>
                            </a>
                        </li>
                        <li className="social-twitter">
                            <a href="https://www.linkedin.com/company/kabra-express-logistics-private-limited/">
                                <i className="fa fa-linkedin"></i>
                            </a>
                        </li>
                        <li className="social-youtube">
                            <a href="https://www.instagram.com/kabra.express/">
                                <i className="fa fa-instagram"></i>
                            </a>
                        </li>
                        <li className="social-youtube">
                            <a href="https://www.youtube.com/channel/UCt4wx_zJAyQ-el--Jy3iurQ">
                                <i className="fab fa-youtube"></i>
                            </a>
                        </li>
                        <li className="social-twitter">
                            <a href="#">
                                <i className="fa fa-twitter"></i>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="col-sm-6 col-md-6 text-center poweredByText">
                    <strong>
                        Powered by{" "}
                        <img src="light-on.png" />{" "}
                        Kabra Express Logistics Pvt. Ltd.
                    </strong>
                </div>
            </div>
        </Fragment>
    );
};

export default withRouter(FooterMobile);
